<template>
  <v-container>
    <v-row>
      <v-col cols="11"> </v-col>
      <v-col cols="1" v-if="showLoader">
        <LoaderProgress></LoaderProgress>
      </v-col>
    </v-row>

    <div
      :key="val.customer_id"
      v-for="val in oeeData"
      style="border-style=solid"
    >
      <v-row @click="goingIntoCustomer(val.customer_id)">
        <v-col>
          <v-btn class="white--text block" dark color="primary">
            {{ val.customer_name }}</v-btn
          >
        </v-col>
      </v-row>
      <v-row >
        <v-col cols="5" style="margin-left:130px">
          <div
            v-if="val.singleMachineOEE != 0"
            class="d-flex align-content-space-around flex-wrap"
          >
            <div
            @click="goingIntoOee(val.customer_id)"
             v-bind:key="apq.id"
              v-for="apq in val.singleMachineOEE"
              class="mb-3 mt-5"
            >
            <SingleMachine v-bind:apq="apq" style="padding-top: 20px"/>

            <!-- <v-col>
                <router-link
                :to="{
                  name: 'OEE Monitoring Dashboard',
                  params: { macId: val.customer_id },
                }"
                style="text-decoration: none"
              >
                  <SingleMachine v-bind:apq="apq" style="padding-top: 20px" />
                </router-link>        
            </v-col> -->
            </div>
            </div>
                    </v-col>

          <v-col>
          <div
            v-if="val.singleMachineEnergy"
            class="d-flex align-content-space-around flex-wrap "
          >
            <div
              @click="goingIntoEnergy(val.customer_id)"
              v-bind:key="energy.id"
              v-for="energy in val.singleMachineEnergy"
              class="mb-3 mt-5"
            >

              <EnergyMachine
                  v-bind:energy="energy"
                  style="padding-top: 20px"
                />
              <!-- <router-link
                :to="{
                  name: 'Energy-Dashboard',
                  params: { macId: val.customer_id },
                }"
                style="text-decoration: none"
              >
                <EnergyMachine
                  v-bind:energy="energy"
                  style="padding-top: 20px"
                />
              </router-link> -->
            </div>
          </div>
          </v-col>
        <!-- </v-col> -->
      </v-row>
      <h1
        v-if="oeeData.length == 0 && !showLoader"
        style="margin-top:10px;"
      ></h1>
    </div>
  </v-container>
</template>
<script>
import axios from "axios";
import LoaderProgress from "../components/progressLoader";
import SingleMachine from "../components/NewOee";
import EnergyMachine from "../components/NewEnergy";
// import constants from "../constants";
import router from "../router";
// import super_admin_guage from "../components/superAdminGauge.vue";

export default {
  components: {
    // super_admin_guage,
    LoaderProgress,
    SingleMachine,
    EnergyMachine,
  },
  prop: ["apqData"],

  data: () => ({
    alertsData: [],
    super_data: [],
    oeeData: [],
    energyData: [],
    showLoader: false,
  }),

  beforeMount() {
    console.log("checlong before mouted he");
    this.super_user_method();
  },
  methods: {
    goingIntoCustomer(id) {
      console.log("checkign id", id);
      sessionStorage.removeItem("route_first_option");

      sessionStorage.setItem("route_first_option", "/");
      sessionStorage.setItem("super_to_user_org_id", `${id}`);

      router.push("/");

      //  this.$root.$emit('value_of_checkbox', gag.customer_id);
    },
    goingIntoOee(id){
      console.log("checkign id-1", id);
            // console.log("in oee",sessionStorage.getItem("route_first_option"))
      sessionStorage.removeItem("route_first_option");
      sessionStorage.setItem("route_first_option", "/multipleOEE");
      sessionStorage.setItem("super_to_user_org_id", `${id}`);
      console.log("in oee",sessionStorage.getItem("route_first_option"))
      console.log("in oee",sessionStorage.getItem("super_to_user_org_id"))

      router.push("/multipleOEE");
    },
     goingIntoEnergy(id){
      console.log("checkign id-1", id);
      sessionStorage.removeItem("route_first_option");

      sessionStorage.setItem("route_first_option", "/EnergyMonitoring");
      sessionStorage.setItem("super_to_user_org_id", `${id}`);
      console.log("in energy",sessionStorage.getItem("route_first_option"))
      console.log("in energy",sessionStorage.getItem("super_to_user_org_id"))

      router.push("/EnergyMonitoring");
    },
    super_user_method: function() {
      console.log("checking details");
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getSuperMachineDetails`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.showLoader = true;
      axios(config)
        .then((response) => {
          this.showLoader = false;
          let data = response.data.data;
          let dataKeys = [];
          Object.entries(data).forEach(([key, value]) => {
            console.log(key, value);
            console.log("data1", data);
            dataKeys.push(key);
          });
          console.log("keys lsit to evalutaiton", dataKeys);
          let structuredAPQ = data.map((e) => {
            console.log("CHecking individual dict", e);
            let id = e.customer_name;
            let oeeData = e.oee_data[0] || {};
            let energyData = e.energy_data[0] || {};
            let availability = oeeData.availability * 100 || 0;
            availability = availability.toFixed(0);
            let performance = oeeData.performance * 100 || 0;
            performance = performance.toFixed(0);
            let quality = oeeData.quality * 100 || 0;
            quality = quality.toFixed(0);
            let oee = (availability * performance * quality) / (100 * 100) || 0;
            oee = oee.toFixed(0);
            let machine_id = oeeData.machine_id || 0;

            let singleMachineOEE = {
              id,
              availability,
              performance,
              quality,
              oee,
              machine_id,
            };
            let avg = energyData.avg;
            avg = avg && typeof avg === "number" ? avg.toFixed(2) : "--";
            let min = energyData.min;
            min = min && typeof min === "number" ? min.toFixed(2) : min;
            let max = energyData.max;
            max = max && typeof max === "number" ? max.toFixed(2) : "--";
            let energy = energyData.total;
            energy =
              energy && typeof energy === "number" ? energy.toFixed(2) : "--";
            let cost = energyData.cost;
            cost = cost && typeof cost === "number" ? cost.toFixed(2) : "--";
            let singleMachineEnergy = {
              id,
              machine_id,
              avg,
              min,
              energy,
              cost,
              max,
            };
            let energySingleCustomerList = [singleMachineEnergy];
            console.log("part-1", energySingleCustomerList);
            console.log("props",e.customer_id)
            // console.log("part-2",this.energySingleCustomerList)
            let add = [singleMachineOEE];
            let dict = {};
            dict["customer_name"] = id;
            dict["customer_id"] = e.customer_id;
            dict["singleMachineOEE"] = add;
            dict["singleMachineEnergy"] = energySingleCustomerList;
            console.log("singleMachineOEE", dict);
            console.log("singleMachineOEE-2", dict.singleMachineEnergy);
            return dict;
          });

          this.oeeData = structuredAPQ;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
  },
};
</script>
<style scoped>
@import "../assets/fonts/style.css";

@media screen and (min-width: 600px) {
  #div2 {
    display: none;
  }
  #ins1 {
    display: none;
  }
}

/* On screens that are 600px wide or less, the background color is olive */
@media screen and (max-width: 600px) {
  #div1 {
    display: none;
  }
  #ins2 {
    display: none;
  }
}

.block {
  display: block;
  width: 100%;
  border: none;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  text-align: left;
}
</style>
